/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Category } from './Category';
import type { Color } from './Color';
import type { Material } from './Material';
import type { Supplier } from './Supplier';
import type { Tag } from './Tag';
import type { User } from './User';
export type Product = {
    /**
     * Unique product identifier
     */
    id: number;
    /**
     * Product code
     */
    code: string;
    /**
     * Product name
     */
    name: string;
    /**
     * Product description
     */
    description?: string;
    /**
     * Product status
     */
    status: Product.status;
    /**
     * Product image path
     */
    imagePath?: Record<string, any>;
    /**
     * If true, a separate S3 object exists at the _thumb key for list/grid URLs
     */
    hasThumbnail: boolean;
    /**
     * Product category
     */
    category: Category;
    /**
     * Product material
     */
    material: Material;
    /**
     * Weight in grams
     */
    weightGrams?: number;
    /**
     * Length in millimeters
     */
    lengthMm?: number;
    /**
     * Talla (columna diameter_size)
     */
    diameterSize?: string;
    /**
     * Properties description
     */
    propertiesDescription?: string;
    /**
     * Product color
     */
    color?: string;
    /**
     * Product color catalog entry
     */
    colorRef?: Color;
    /**
     * Workshop product code
     */
    workshopCode?: string;
    /**
     * Cost price
     */
    costPrice: number;
    /**
     * Sale price
     */
    salePrice: number;
    /**
     * Product supplier
     */
    supplier: Supplier;
    /**
     * Supplier code
     */
    supplierCode?: string;
    /**
     * Created by user
     */
    createdBy: User;
    /**
     * Updated by user
     */
    updatedBy: User;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Last update timestamp
     */
    updatedAt: string;
    /**
     * Product tags
     */
    tags: Array<Tag>;
};
export namespace Product {
    /**
     * Product status
     */
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
    }
}

